import React, { ReactNode } from 'react'

export interface ContainerProviderProps {
  children: ReactNode
}

export const ContainerProvider: React.FC<ContainerProviderProps> = ({ children }) => {
  // Note: DI container setup is now handled by AppBootstrap during initialization
  return <>{children}</>
}